

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMPLOYEEBYLOGIN= createAsyncThunk(
  "getEmployeeBylogin/getEmployeeBylogin",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmployeeByloginSlice = createSlice({
  name: "getEmployeeByloginSlice",
  initialState: {
    getEmployeeBylogin: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmployeeBylogin: (state) => {
        state.getEmployeeBylogin.loading = false
        state.getEmployeeBylogin.error = false
        state.getEmployeeBylogin.data = []
        state.getEmployeeBylogin.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMPLOYEEBYLOGIN.fulfilled, (state, action) => {
      state.getEmployeeBylogin = {
        ...state.getEmployeeBylogin,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEBYLOGIN.pending, (state, action) => {
      state.getEmployeeBylogin = {
        ...state.getEmployeeBylogin,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMPLOYEEBYLOGIN.rejected, (state, action) => {
      state.getEmployeeBylogin = {
        ...state.getEmployeeBylogin,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmployeeByloginAction = {
    GETEMPLOYEEBYLOGIN,
};

export { getEmployeeByloginAction };
export default getEmployeeByloginSlice.reducer;
export const {setInitialStateOfgetEmployeeBylogin} = getEmployeeByloginSlice.actions
